import {
  RENTS_RESET,
  RENTS_DOWNLOADED,
  RENT_DOWNLOADED,
  RENTS_FAILED,
  RENTS_PENDING,
  RENT_SENDING,
  RENTS_CLIENT_DOWNLOADED,
  RENTS_CSV_DOWNLOADED, RENTS_CSV_PENDING,
} from './types';
import RentsApiService from '../../services/api/RentsApiService';
import { handleError } from '../infos/actions';

export const rentsResetAction = () => ({
  type: RENTS_RESET,
});

export const rentDownloadedAction = (rent) => ({
  type: RENT_DOWNLOADED,
  payload: rent,
});

export const rentsDownloadedAction = (rents) => ({
  type: RENTS_DOWNLOADED,
  payload: rents,
});

export const rentsClientsDownloadedAction = (rents) => ({
  type: RENTS_CLIENT_DOWNLOADED,
  payload: rents,
});

export const rentsCSVDownloadedAction = (csv) => ({
  type: RENTS_CSV_DOWNLOADED,
  payload: csv,
});

export const rentsFailedAction = (error) => ({
  type: RENTS_FAILED,
  payload: error,
});

export const rentsPendingAction = () => ({
  type: RENTS_PENDING,
});

export const rentsCSVPendingAction = () => ({
  type: RENTS_CSV_PENDING,
});

export const rentSendingAction = () => ({
  type: RENT_SENDING,
});

export function resetRents() {
  return (dispatch) => {
    dispatch(rentsResetAction());
  };
}

export function getRents(authUserToken, role, limit, page, renters) {
  return (dispatch) => {
    dispatch(rentsPendingAction());
    return RentsApiService
      .getRents(authUserToken, role, limit, page, renters)
      .then((data) => {
        dispatch(rentsDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(rentsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function getAllRentsByUser(authUserToken, role, user) {
  return (dispatch) => {
    dispatch(rentsPendingAction());
    return RentsApiService
      .getAllRentsByUser(authUserToken, role, user)
      .then((data) => {
        dispatch(rentsClientsDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(rentsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function putRentEnded(authUserToken, rentId, rent) {
  return (dispatch) => {
    dispatch(rentSendingAction());
    return RentsApiService
      .putRentEnded(authUserToken, rentId, rent)
      .then((data) => {
        dispatch(rentDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(rentsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function putCloseRent(authUserToken, rentId, rent) {
  return (dispatch) => {
    dispatch(rentSendingAction());
    return RentsApiService
      .putCloseRent(authUserToken, rentId, rent)
      .then((data) => {
        dispatch(rentDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(rentsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function getCSVRents(authUserToken) {
  return (dispatch) => {
    dispatch(rentsCSVPendingAction());
    return RentsApiService
      .getCSVRents(authUserToken)
      .then((data) => {
        dispatch(rentsCSVDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(rentsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/rents/actions.js